import tokeys from 'tokeys';

export const StorageTypes = tokeys([
  'local_storage',
  'session_storage',
  'cookies'
]);

export default StorageTypes;
